import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indiancurrency',
})
export class IndiancurrencyPipe implements PipeTransform {
  transform(value: number): any {
    if (!isNaN(value) && value) {
      const currencySymbol = '₹';
      let output = '';
      const result = value.toString().split('.');

      let lastThree = result[0]?.substring(result[0].length - 3);
      const otherNumbers = result[0].substring(0, result[0].length - 3);
      if (otherNumbers !== '') {
        lastThree = ',' + lastThree;
      }
      output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

      return currencySymbol + output;
    }
  }
}
